<template>
    <div class="header">
        <div class="content">
            <div class="logo">
                <img src="../../../assets/images/shilin/logo.png">
            </div>
            <div class="right">
                <div class="top">
                    <div class="language">
                        <span :class="{'on' : isshowlan}" @click="show()">中文</span>
                        <div class="lang-cont" v-if="isshowlan">
                            <ul>
                                <li v-for="item in language" :key="item.type" @click="goto(item.type)">{{item.value}}</li>
                            </ul>
                        </div>
                   </div>
                    <HeaderBar :width="pageWidth" :bgColor="bgColor"
                     :loginText='loginText'
                     :registerText='registerText'
                     :registerTextColor='registerTextColor' 
                     :loginTextColor="loginTextColor" 
                     v-if="!isForeign">
                    </HeaderBar>
                     <div class="phone">旅游资讯电话：0476-5070998</div>
                   
                </div>
                <div class="nav" v-if="!isForeign">
               <div
                class="tab-item"
                v-for="item in tabList"
                :key="item.value"
                :class="{on: item.routeName === value}"
               
               >
                 <div v-if="item.routeName !=='shilinbook'"  @click="onTabClick(item)">
                    {{ item.label }}
                 </div>
                 <div v-else @click="onTabClick2(item)"> {{ item.label }}</div>
               
                <em v-if="item.routeName === value"> <img src="../../../assets/images/shilin/nav_on.png"></em>
                <div class="child" v-if="item.routeName === value && ShowChild">
                    <span 
                    v-for="sitem in item.children"
                    :key="sitem.value"
                    :class="{on: item.routeName === value}"
                     @click="onTabClick(sitem)"
                    >{{ sitem.label }}</span>  
                </div>
             </div>
             </div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
import { apiGet } from "@/fetch/api";

import { mapState } from "vuex";
import HeaderBar from "@/components/headerBar";

export default {
    props: {
        tabList: {
        type: Array,
        default: () => []
        },
        value: {
        type: String,
        default: "home"
        },
        isForeign:{
        type: Boolean,
        default: false
        },
        
    },
     components: {
       HeaderBar,
      
    },
    data() {
    return {
      current: "",
      showLoginModel:false,
      pageWidth:100,
      bgColor:'',
      loginText:'登录',
      registerText:'注册',
      registerTextColor:'#fff',
      loginTextColor:'#fff',
      ShowChild:false,
      isshowlan:false,
      langType:'chinese',
      language:[
        {
        type:'chinese',
        value:'中文',
        },
        {
        type:'EN',
        value:'EN',
        },
        {
        type:'Монгол',
        value:'Монгол',
        },
        {
        type:'한.',
        value:'한.',
        }
      ]
     };
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id",''])
  },
  mounted(){
  
   
  },
methods: {
    show(){
      this.isshowlan=!this.isshowlan;
    },
    onTabClick(data) {
        if (data.value === this.value) {
            return;
        }
      this.$emit("change", data);
    },
    goto(type){
        this.langType=type;
        if(type==='chinese'){
            this.$router.push('/index?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id));
            localStorage.setItem('selectValue','shilinHomePage');
        }
        if(type==='EN'){
            this.$router.push('/Eindex?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id)+'&id=2501&menuId=922');
        }
        if(type==='Монгол'){
            this.$router.push('/Eindex?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id)+'&id=2502&menuId=922');
        }
        if(type==='한.'){
            this.$router.push('/Eindex?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id)+'&id=2503&menuId=922');
        }
        this.isshowlan=!this.isshowlan;
        this.$emit("lang", type);
    },
    onTabClick2(data) {
        this.ShowChild=data.value==='shilinbook';
        this.$emit("change", data);
    },
    loginChange(bool, isLoginRegister) {
        this.$parent.loginChange(bool, isLoginRegister)
    },
    

}
  
}
</script>
<style scoped lang="scss">
.header{
    width: 100%;
    height: 102px;
    background:rgba(0,0,0,0.58);
   .content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .logo{
        width: 307px;
        height: 104px;
        margin-right: 90px;
    }
    .right{
        width: 100%;
        height: 102px;
        color: #fff;
        .top{
            width: 100%;
            text-align: right;
            margin-top: 10px;
            display: flex;
            flex-direction: row-reverse;
            .phone{
                background: url('../../../assets/images/shilin/phone.png') no-repeat left center;
                padding-left: 18px;
            }
          .header-top-bar{
             width: 166px; 
             height: auto;
          }  
         .login{
             cursor: pointer;
         } 
         .regsiter{
            cursor: pointer;
            color:#126c42 ;
            padding-left: 20px;
         } 
        .language{
            .lang-cont{
                position: absolute;
                background: #515467;
                width:63px ;
                text-align: center;
                padding-top: 5px;
                padding-bottom: 5px;
                z-index: 99;
                li{
                    padding: 8px;
                    cursor: pointer;
                }

            }
           span{
                text-align: center;
                display: inline-block;
                width: 63px;
                cursor: pointer;
                background: url('../../../assets/images/shilin/up_icon1.png') no-repeat right center;
                padding-right: 10px;
                
            }
            .on{
               background: url('../../../assets/images/shilin/down_icon.png') no-repeat right center;
            }   
        }
         
        }
    }
    
    .nav{
       display: flex;
      .tab-item{
           width: 125px;
           text-align: center;
           color: #fff;
           font-size: 16px;
           margin-top: 25px;
           cursor: pointer;
           em{
               display: block;
               width: 36px;
               height: 4px;
               margin: 0 auto;
               margin-top: 20px;
           }
        }
        .child{
            position:fixed;
            background:#515467;
            z-index: 5;
            width: 125px;
            margin-top: 1px;
            span{
                display: block;
                text-align: center;
                padding: 10px 0;
                cursor: pointer;
                opacity: 0.5;
              .on{
                  opacity: 1;
              }
            }
        }
       
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/shilin/components/header.vue